<template>
  <main class="container container-choose-route d-flex flex-column align-items-center">
    <CustomerChangePasswordComponent></CustomerChangePasswordComponent>
  </main>
</template>

<script lang="ts">
import './changePassword.scss';

import axios from "axios";
import apiService from "../../services/apiService";
import {useStore} from "vuex";
// @ts-ignore
import CustomerChangePasswordComponent from "../../components/CustomerChangePassword/CustomerChangePasswordComponent";
import {defineComponent} from "vue";

export default defineComponent({
  name: "ChangePasswordPage",
  components: {
    CustomerChangePasswordComponent
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {}
  },
  methods: {},
  created() {
    axios.get(apiService.pageChangePasswordPageEndpoint())
        .then()
        .catch(error =>
            console.error(error)
        );
  },
})
</script>